"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _color = _interopRequireDefault(require("color"));
var _arrowRight = _interopRequireDefault(require("cccisd-icons/arrow-right20"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down20"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _default = exports["default"] = function _default(props) {
  var isLight = true;
  if (props.secondaryColor && props.secondaryColor.length > 0) {
    isLight = (0, _color["default"])(props.secondaryColor).luminosity() > 0.5;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].wrapper,
    style: {
      borderColor: props.primaryColor
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].header,
    onClick: function onClick() {
      return props.handleCollapse(props.id);
    },
    style: {
      backgroundColor: props.secondaryColor
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerIcon,
    style: {
      color: props.primaryColor
    }
  }, props.collapsed.includes(props.id) ? /*#__PURE__*/_react["default"].createElement(_arrowRight["default"], {
    spaceRight: true
  }) : /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], {
    spaceRight: true
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerContent
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerTitle,
    style: {
      color: props.primaryColor
    }
  }, props.title), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].headerDesc,
    style: isLight ? {
      color: '#666'
    } : {
      color: '#fff'
    }
  }, props.description))), !props.collapsed.includes(props.id) && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].content
  }, props.children));
};